<template>
    <div class="w-full text-black">
        <div class="pb-[18px] border-b flex items-end justify-between">
            <div>
                <h2 class="text-[20px] font-light">Document</h2>
                <p class="text-[13px] font-extralight mt-2">Liste des documents</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "UserDocument"
}
</script>